import axios from "axios";
import router from "../router";
import QS from "qs";
import tips from "@/utils/global";
import { getSessionStore } from "@/utils/sessionStorage";

axios.defaults.withCredentials = true; //携带cookie
axios.defaults.timeout = 10000; //延迟时间
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

// 请求的拦截器
axios.interceptors.request.use(
  function(config) {
    const access_token = sessionStorage.getItem("access_token");
    if (access_token) {
      config.headers['Authorization'] = 'Bearer ' + access_token;
    }
    if (config.method === "post") {
      config.data =
        config.data instanceof FormData
          ? config.data
          : QS.stringify(config.data);
    }
    return Promise.resolve(config);
  },
  function(error) {
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
    if (error.message === "Network Error") {
      router.replace({
        path: "/login"
      });
    }
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          break;
        case 403:
          tips.error("登录过期，请重新登录");
          break;

        // 404请求不存在
        case 404:
          tips.error("网络请求不存在");
          break;
        // 其他错误，直接抛出错误提示
        default:
          if (error.response.data.message) {
            tips.error(error.response.data.message);
          }
      }
      return Promise.reject(error.response);
    }
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params, isNoToken) {
  const access_token = getSessionStore("access_token");
  params = params ? params : {};
  if (access_token && !isNoToken) {
    params.access_token = access_token;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params || {}
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params || {})
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

/**
 * 文件上传
 * @param {String} url
 * @param {Object} params
 */
export function postFile(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params || {}, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
